import { RequestContext } from '@mastra/client-js';

import type { TellentAssistantAppContext } from '@core/tellent-assistant-types';
import { toWireAppContext } from '@core/tellent-assistant-util';

export function setChatAppContext(
  requestContext: RequestContext,
  context: TellentAssistantAppContext,
): void {
  requestContext.set('chatAppContext', toWireAppContext(context));
}
